<ng-template #defaultTabButtons let-c="close" let-d="dismiss">
    <!-- <div class="modal-body text-white backgroundTable">
        <div class="row ">
                <div class="col-9 bd-highlight">
                    <h6 class="mt-2 ms-3">Crear Indicador test</h6>
                </div>
                <div class="col-3 d-flex flex-row-reverse bd-highlight">
                    
                        <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>

                </div>
                
        </div>
        
        <div class="p-3 row" >
            <form
                action=""
                method="post"
                (submit)="formSubmit()"
                [formGroup]="dependenceForm">
            <div *ngFor="let item of listIndicators" class="form-group col-12">
                <div class="d-flex justify-content-start mt-4 mb-2">
                    <label for="endDate" class="text-white">{{item.name}}</label>
                </div>
                <select required class="custom-outline-input form-control" id="{{item.id}}" formControlName="{{'e'+item.id}}" >
                <option selected value="">Seleccione una calificacion</option>
                <option *ngFor="let item of listStado" [value]="item.id">
                  {{ item.name }} 
                </option>
              </select>
            </div>
            <div class="mt-4 form-group d-flex custom-checkbox col-12 align-items-center">
                <label for="semana" class="text-white">Semana anterior:</label>
                <input type="checkbox" class="ms-3 custom-outline-check form-check-input fs-3" formControlName="semana" name="" id="semana">
            </div>
            <br>
            <div class="col-12 mt-3 d-flex justify-content-center">
                <button class="btn btn-outline-light ">Guardar</button>
            </div>
            </form>
        </div>
    </div> -->

    <div class="backgroundTable text-white" ngbAutofocus>
        <div class=" mx-5 ">
          <div class="row my-2">
            <div class="col-9 align-self-center p-2 bd-highlight">Crear Indicador</div>
            
            <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
          </div>
        </div>
        <div class="componente-importantes-from-popup  p-3">
            <form
                action=""
                class="p-3"
                method="post"
                (submit)="formSubmit()"
                [formGroup]="dependenceForm">
            <div *ngFor="let item of listIndicators" class="form-group col-12">
                <div class="d-flex justify-content-start mt-4 mb-2">
                    <label for="endDate" class="text-white">{{item.name}}</label>
                </div>
                <select required class="custom-outline-input form-control" id="{{item.id}}" formControlName="{{'e'+item.id}}" >
                <option selected value="">Seleccione una calificacion</option>
                <option *ngFor="let item of listStado" [value]="item.id">
                  {{ item.name }} 
                </option>
              </select>
            </div>
            <div class="mt-4 form-group d-flex custom-checkbox col-12 align-items-center">
                <label for="semana" class="text-white">Semana anterior:</label>
                <input type="checkbox" class="ms-3 custom-outline-check form-check-input fs-3" formControlName="semana" name="" id="semana">
            </div>
            <br>
            <div class="col-12 mt-3 d-flex justify-content-center">
                <button class="btn btn-outline-light ">Guardar</button>
            </div>
            </form>
            </div>

        
        </div>

</ng-template>